import { render } from "./QuestionFormBuilder.vue?vue&type=template&id=aec5acc8&scoped=true"
import script from "./QuestionFormBuilder.vue?vue&type=script&lang=js"
export * from "./QuestionFormBuilder.vue?vue&type=script&lang=js"

import "./QuestionFormBuilder.vue?vue&type=style&index=0&id=aec5acc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec5acc8"]])

export default __exports__